<template>
  <div class="sidebar">
    <ul class="baritems" v-if="!empty">
      <router-link to="/plans/select" v-show="!isAuditing">
        <li :class="{ active: $route.path === '/plans/details' }">
          Select QHA
        </li>
      </router-link>
      <!-- <router-link to="/plans/details"> -->
      <a
        :class="{ 'is-active': $route.params.id === 'a' }"
        @click="didClickNavigateToSection('a')"
        v-show="isAuditing"
      >
        <li>
          1. Timeliness & Details
          {{ showIfDirty('a') }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'b' }"
        @click="didClickNavigateToSection('b')"
        v-show="isAuditing"
      >
        <li>
          2. SEN health needs
          {{ showIfDirty('b') }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'c' }"
        @click="didClickNavigateToSection('c')"
        v-show="isAuditing"
      >
        <li>
          3. Non SEN health needs
          {{ showIfDirty('c') }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'd' }"
        @click="didClickNavigateToSection('d')"
        v-show="isAuditing"
      >
        <li>
          4. Outcomes
          {{ showIfDirty('d') }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'e' }"
        @click="didClickNavigateToSection('e')"
        v-show="isAuditing"
      >
        <li>
          5. Provision
          {{ showIfDirty('e') }}
        </li>
      </a>
      <a
        :class="{ 'is-active': $route.params.id === 'f' }"
        @click="didClickNavigateToSection('f')"
        v-show="isAuditing"
      >
        <li>
          6. Co-production
          {{ showIfDirty('f') }}
        </li>
      </a>
      <!-- <a
        :class="{ 'is-active': path === 'additional-components' }"
        @click="didClickNavigateTo('additional-components')"
        v-show="isAuditing"
      >
        <li>
          7. Additional Components
          {{ showIfDirty('additional-components') }}
        </li>
      </a> -->
      <a
        :class="{ 'is-active': path === 'next-steps' }"
        @click="didClickNavigateTo('next-steps')"
        v-show="isAuditing"
      >
        <li>
          7. Next Steps
          {{ showIfDirty('additional') }}
        </li>
      </a>
      <a
        :class="{ 'is-active': path === 'summary' }"
        @click="didClickNavigateTo('summary')"
        v-show="isAuditing"
      >
        <li>8. Summary</li>
      </a>
      <!-- <li class="text-sm">Submit Gradings</li> -->
    </ul>
    <ul class="baritems" v-else>
      <router-link to="/support">
        <li>Help and Support</li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SideBar',
  props: ['empty', 'touched'],
  computed: {
    ...mapGetters({
      sections: 'audit/sections',
      nextSection: 'audit/nextSection',
      currentAudit: 'audit/id'
    }),
    path() {
      return this.$route.path.split('/').pop()
    },
    isAuditing() {
      return !!this.currentAudit
    },
    sectionInView() {
      return {
        section5: this.$route.params.id === 'e' || this.$route.params.id === 'f'
      }
    }
  },
  methods: {
    didClickNavigateToSection(section) {
      return this.$router.push({
        path: `/plans/section/${section}`,
        query: { regrade: true }
      })
    },
    didClickNavigateTo(page) {
      if (page !== this.path && page === 'summary') {
        this.$emit('nav-clicked', { id: this.path })
        return this.$router.push({
          path: `/plans/audit/${page}`
        })
      } else if (page !== this.path) {
        this.$emit('nav-clicked', { id: this.path })
        return this.$router.push({
          path: `/plans/audit/${page}`,
          query: { regrade: true }
        })
      }
    },
    didClickViewGradings() {
      this.$emit('nav-clicked', { id: this.path })
      return this.$router.push('/plans/audit/summary')
    },
    hasCompletedSection(section) {
      return this.sections.some(s => s.id === section)
    },
    showIfDirty(section) {
      if (this.touched.length) {
        return this.touched.some(s => s === section) ? ' *' : ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/nav.scss';

.text-sm {
  font-size: 0.75rem;
}

.sub-item {
  padding-left: 20px;
}
</style>
